export const COOKIE_XSS = "CNAPX";
export const COOKIE_AUTHTOKEN = "AUTH";

export const PERMISSION_ADDCLIENT = 1;
export const PERMISSION_VIEWPORTAL = 2;
export const PERMISSION_VIEWUSERS = 3;
export const PERMISSION_EDITUSERS = 4;
export const PERMISSION_VIEWMESSAGES = 5;
export const PERMISSION_VIEWPOSTBACKLOGS = 6;
export const PERMISSION_VIEWAPIKEYS = 7;
export const PERMISSION_EDITAPIKEYS = 8;
export const PERMISSION_VIEWBILLINGINFORMATION = 9;
export const PERMISSION_ADDEDITCLIENTS = 10;
export const PERMISSION_ADMINACCESSTOALLCLIENTS = 11;
export const PERMISSION_SENDTESTMESSAGES = 12;

export const MOMENT_FORMAT_DATETIME = "M/D/YYYY h:mm A";

export const MESSAGE_TYPE_EMAIL = "Email";
export const MESSAGE_TYPE_VOICE = "Voice";
export const MESSAGE_TYPE_PUSH = "Push";
export const MESSAGE_TYPE_SMS = "SMS";

export const MACHINE_DETECTION_HUMAN = "HUMAN";
export const MACHINE_DETECTION_MACHINE = "MACHINE";
export const MACHINE_DETECTION_FAX = "FAX";
export const MACHINE_DETECTION_UNKNOWN = "UNKNOWN";


export const POSTBACKACTION_TYPE_BOUNCE = "BOUNCE";
export const POSTBACKACTION_TYPE_DELIVERYRECEIPT = "DELIVERYRECEIPT";
export const POSTBACKACTION_TYPE_ERROR = "ERROR";
export const POSTBACKACTION_TYPE_INCOMING = "INCOMING";
export const POSTBACKACTION_TYPE_INVALIDPHONE = "INVALIDPHONE";
export const POSTBACKACTION_TYPE_INVALIDREGISTRATION = "INVALIDREGISTRATION";
export const POSTBACKACTION_TYPE_NORESPONSE = "NORESPONSE";
export const POSTBACKACTION_TYPE_RESPONSE = "RESPONSE";
export const POSTBACKACTION_TYPE_RESPONSERECEIVED = "RESPONSERECEIVED";
export const POSTBACKACTION_TYPE_SENT = "SENT";
export const POSTBACKACTION_TYPE_TEST = "TEST";



// WEBPACK FOOTER //
// ./src/core/constants.ts